import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { BulkValidationSummarySchema, makeValidatedRowSchema } from '../../shared/bulk-validation.schema';
import { InitializeSystemInputSchema } from '../initialize-add-systems/initialize-add-systems.schema';
/**
 * Validated System Row Schema
 * Echoes the input row plus resolved ids.
 */ export const ValidatedSystemRowSchema = makeValidatedRowSchema(InitializeSystemInputSchema.extend({
    ownerId: z.string().optional(),
    /** Set when a same-name system already exists (row will be skipped) */ existingSystemId: z.string().optional()
}));
/**
 * Initialize Validate Systems Request Schema
 * POST /api/v2/initialize/systems/validate — dry-run twin of the commit
 * endpoint's create path (updates/removals are commit-only), no writes.
 */ export const InitializeValidateSystemsRequestSchema = z.object({
    systems: z.array(InitializeSystemInputSchema)
});
export const InitializeValidateSystemsResponseSchema = BulkValidationSummarySchema.extend({
    systems: z.array(ValidatedSystemRowSchema)
});
export const InitializeValidateSystemsErrorSchema = BaseErrorSchema;

//# sourceMappingURL=initialize-validate-systems.schema.js.map